import React from 'react';
import { Box } from '@mui/material';
import logoImg from '../../assets/logo.png';

/**
 * NebenanHilfeLogo - Official Logo Component for NebenanHilfe.de
 * Supports full brand logo (with typography & slogan) or iconOnly emblem mode.
 */
const NebenanHilfeLogo = ({ size = 'medium', iconOnly = false }) => {
  const height = size === 'large' ? (iconOnly ? 100 : 72) : size === 'small' ? 38 : 52;

  if (iconOnly) {
    // Pure Emblem SVG (Wreath, Cross, Golden Heart, Helping Hands) without text
    return (
      <Box
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          userSelect: 'none',
          width: height,
          height,
        }}
      >
        <svg viewBox="0 0 100 100" style={{ width: '100%', height: '100%', display: 'block' }}>
          <defs>
            <linearGradient id="emblemCrossGrad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#0077b6" />
              <stop offset="100%" stopColor="#004477" />
            </linearGradient>
            <linearGradient id="emblemHeartGrad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#fbbf24" />
              <stop offset="100%" stopColor="#d97706" />
            </linearGradient>
            <linearGradient id="leafGreen" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#84cc16" />
              <stop offset="100%" stopColor="#4d7c0f" />
            </linearGradient>
            <linearGradient id="leafBlue" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#38bdf8" />
              <stop offset="100%" stopColor="#0284c7" />
            </linearGradient>
          </defs>

          {/* Left Wreath Branch (Green) */}
          <path d="M 22 75 C 10 50 20 25 38 15 C 33 24 35 36 40 43 C 32 38 25 45 22 55 C 18 64 22 72 22 75 Z" fill="url(#leafGreen)" />

          {/* Right Wreath Branch (Blue) */}
          <path d="M 78 75 C 90 50 80 25 62 15 C 67 24 65 36 60 43 C 68 38 75 45 78 55 C 82 64 78 72 78 75 Z" fill="url(#leafBlue)" />

          {/* Bottom People Holding Hands Cradle */}
          <path d="M 24 74 Q 50 94 76 74 C 70 88 30 88 24 74 Z" fill="#0284c7" />
          <circle cx="28" cy="62" r="5" fill="#0284c7" />
          <circle cx="72" cy="62" r="5" fill="#0284c7" />

          {/* Central Cross */}
          <rect x="44" y="24" width="12" height="42" rx="3" fill="url(#emblemCrossGrad)" />
          <rect x="30" y="32" width="40" height="12" rx="3" fill="url(#emblemCrossGrad)" />

          {/* Caring Hand under Heart */}
          <path d="M 42 62 Q 52 56 64 54 Q 60 62 48 66 Z" fill="#004477" />

          {/* Golden Heart */}
          <path d="M 58 45 C 55 40 48 41 46 47 C 44 53 52 59 58 63 C 64 59 72 53 70 47 C 68 41 61 40 58 45 Z" fill="url(#emblemHeartGrad)" />
        </svg>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        userSelect: 'none',
        py: 0.5,
      }}
    >
      <img
        src={logoImg}
        alt="NebenanHilfe.de - Für einander in Nächstenliebe"
        style={{
          height: `${height}px`,
          width: 'auto',
          maxWidth: '100%',
          objectFit: 'contain',
          display: 'block',
        }}
      />
    </Box>
  );
};

export default NebenanHilfeLogo;
